// ────────────────────────────────────────────────────────────────────────────────
// Appointment Thunks
// ────────────────────────────────────────────────────────────────────────────────
// All appointment-related async operations: CRUD, attendance, follow-up handling

import { dispatch, store } from '../../store';
import { updateError } from '../user';
import { callApi } from '../../../utils/apiCall';
import { errorHandler } from '../../../utils/errorHandler';
import { setLoader } from '../loader';
import { creteTreatmentPaymentFlow } from '../deposit';
import { getCurrentTreatmentIdV2 } from '../clincheck';
import { leadActions, startLoadingData, updateCompleteStatus } from './slice';

import { CompleteTreatment, StartingTreatment, UpdateTreatmentV2 } from './treatmentThunks';
import { addNotes, updatePersonalDetail, getCurrentTreatmentData, getCurrentLeadAppointmentId, patchLeadMetadata } from './coreThunks';
import { leadTreatmentPayment } from './financialThunks';
import { addReminder } from './taskThunks';

export function addAppointment(data, practiceId, id, handleClose, status) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${id}/appointments/`, 'post', data);
            if (response?.status === 201) {
                dispatch(leadActions.saveAppointment(response.data));
                const { activeTab, newLeadDetail, attendance, createLead, tableRowLead, action } = store.getState().lead;
                const { depositData } = store.getState().deposit;
                if (depositData?.isDepositFlow) {
                    dispatch(creteTreatmentPaymentFlow());
                }
                if (status && status?.toLowerCase?.() === 'finish') {
                    dispatch(updateError({ success: true, message: 'Treatment started successfully' }));
                    dispatch(updateCompleteStatus(false));
                    handleClose('finish', id);
                    dispatch(startLoadingData(false));
                    return;
                }

                const { currentTreatmentDataGlobal } = store.getState().multiTreatment;
                if (action === 'startTreatment') {
                    let startTreatments = {
                        lead: data?.lead || newLeadDetail?.personalDetail?.id,
                        id: currentTreatmentDataGlobal?.treatmentData?.id || newLeadDetail?.lead_treatment?.id || tableRowLead?.treatment_id
                    };
                    if (newLeadDetail?.lead_treatment) {
                        startTreatments = {
                            ...startTreatments,
                            ...newLeadDetail?.lead_treatment,
                        };
                    }
                    dispatch(StartingTreatment(startTreatments, practiceId, handleClose, 'startingTreatmentFinish'));
                    return;
                }
                if (action === 'completeTreatment') {
                    const completeTreatment = {
                        ...newLeadDetail?.lead_treatment
                    };
                    dispatch(CompleteTreatment(completeTreatment, data?.lead || newLeadDetail?.personalDetail?.id, currentTreatmentDataGlobal?.treatmentData?.id || newLeadDetail?.lead_treatment?.id || tableRowLead?.treatment_id, practiceId, handleClose));
                    return;
                }
                if (attendance === 'attendance' && activeTab === 2) {
                    const { noteDetail } = newLeadDetail?.attentendAppoiment || {};
                    if (noteDetail) dispatch(addAppointmentNotes(practiceId, id, response.data.id, noteDetail, handleClose));
                    return;
                }
                if (attendance === 'payment' && (status && status === 'followUp') && activeTab >= 2) {
                    dispatch(updatePersonalDetail({ ...newLeadDetail.personalDetail, id: tableRowLead.lead_id ?? tableRowLead.id }, practiceId, handleClose, 'personalDetail'));
                    return;
                }

                if (attendance === 'payment' && (status && status === 'CreatLead') && activeTab >= 2 && newLeadDetail.payment.payment_type !== 'No') {
                    dispatch(leadTreatmentPayment(practiceId, createLead.lead_treatment.lead, createLead.lead_treatment.id, newLeadDetail.payment, handleClose));
                    return;
                }

                // if (attendance === 'payment' && activeTab >= 2) {
                // 	// const reminderDetail = {
                // 	// 	...newLeadDetail.lead_reminder,
                // 	// 	lead : createLead.id,
                // 	// 	lead_treatment : createLead.lead_treatment ? createLead.lead_treatment.id : tableRowLead.treatment_id,
                // 	// 	lead_appointment : createLead.lead_appointment ? createLead.lead_treatment.id : 0
                // 	// }
                // 	// dispatch(addReminder(reminderDetail, practiceId, handleClose));
                // 	dispatch(updateError({ success: true, message: 'Treatment and Appointment Added successfully' }));
                // 	dispatch(updateCompleteStatus(false));
                // 	handleClose('finish');
                // 	return;
                // }
                if (status === 'RescheduleReminder') {
                    dispatch(updateError({ success: true, message: 'Appointment added successfully' }));
                    dispatch(getAppointment(practiceId, id));
                    dispatch(updateCompleteStatus(false));
                    handleClose('finish', id);
                    dispatch(startLoadingData(false));
                    return;
                }
                if (status === 'AddAppointment') {
                    dispatch(updateError({ success: true, message: 'Appointment added successfully' }));
                    dispatch(getAppointment(practiceId, id));
                    dispatch(followUpSlice(id, practiceId, 'LeadDetail'));
                    dispatch(updateCompleteStatus(false));
                    handleClose('finish', id);
                    dispatch(startLoadingData(false));
                    return;
                }
                if (status === 'Reschedule') {
                    dispatch(updateError({ success: true, message: 'Appointment added successfully' }));
                } else {
                    dispatch(updateError({ success: true, message: 'Treatment and Appointment added successfully' }));
                }
                dispatch(updateCompleteStatus(false));
                handleClose('finish', id);
                dispatch(startLoadingData(false));

            } else {
                dispatch(updateCompleteStatus(false));
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
                dispatch(startLoadingData(false));
                dispatch(setLoader(false));
            }
        } catch (error) {
            dispatch(setLoader(false));
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
        }
    };
}

export function getAppointment(practiceId, id) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${id}/appointments/?fields={id,status,datetime,datetime_human,method,type,contacted_via,note,assignees,lead_treatment,lead_treatments}`);
            if (response?.status === 200) {
                dispatch(leadActions.followUpAppointment(response.data.results));
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function UpdateAppointment(data, practiceId, handleNext, status) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead}/appointments/${data.id}/`, 'put', data);
            if (response?.status === 200) {
                dispatch(leadActions.saveAppointment(response.data));
                if (status === 'RescheduleReminder') {
                    handleNext?.('finish', data?.lead);
                    dispatch(getAppointment(practiceId, data?.lead));
                    dispatch(updateError({ success: true, message: 'Appointment updated successfully' }));
                }
                if (status === 'Reschedule') {
                    handleNext?.('finish', data?.lead);
                    dispatch(updateError({ success: true, message: 'Appointment updated successfully' }));
                }
                handleNext?.({ success: true, message: 'Appointment updated successfully' });
            }
            dispatch(startLoadingData(false));
        } catch (error) {
            const message = error?.message || 'An error occurred while updating the appointment';
            handleNext?.({ message, success: false });
            dispatch(leadActions.hasError(message));
        }
    };
}

export function FailedToAttendAppointment(data, leadId, id, practiceId, handleClose, activeTab) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/failed_to_attend/`, 'post', data);
            const { newLeadDetail: { archiveLead }, tableRowLead } = store.getState().lead;
            if (response?.status === 200) {
                if (activeTab === 'failedAttendTreatment') {
                    handleClose({ success: true });
                    dispatch(startLoadingData(false));
                    return;
                }
                dispatch(updateError({ success: true, message: 'Appointment failed successfully' }));
                if (activeTab === 'Unable to contact') {
                    dispatch(unableToContact(handleClose));
                    return;
                }
                if (activeTab === 'Archive') {
                    const archiveNote = {
                        ...archiveLead.notes,
                        lead: tableRowLead.lead_id
                    };
                    dispatch(addNotes(archiveNote, practiceId, handleClose));
                    return;
                }
                if (activeTab === 'Reschedule') {
                    dispatch(Reschedule(handleClose));
                }
            } else {
                errorHandler(response.data, handleClose, leadActions.hasError);
            }
        } catch (error) {
            errorHandler(error, handleClose, leadActions.hasError);
        }
    };
}

export function followUpSlice(id, practiceId, LeadDetail, handleClose) {
    return async () => {
        try {
            // Slim payload: omits heavy form_submissions[*].fields[*]. Only ScriptListing
            // needs the full fields, and it lazy-fetches them via the dedicated endpoint.
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${id}/?slim=true`);
            if (response?.status === 200) {
                if (handleClose) {
                    handleClose(response.data);
                }
                if (LeadDetail === 'LeadDetail') {
                    dispatch(leadActions.saveLeadDetail(response.data));
                    dispatch(leadActions.followUpLead(response.data));
                    return;
                }
                dispatch(leadActions.followUpLead(response.data));
                const newCreateLead = {
                    id: response.data.id,
                    first_name: response.data.first_name,
                    last_name: response.data.last_name,
                    salutation: response.data.salutation,
                    dob: response.data.dob,
                    address: response.data?.lead_address === null ? '' : response.data?.lead_address,
                    lead_contact: {
                        email: response.data?.lead_contact.email,
                        note: response.data?.lead_contact.note,
                        phone: response.data?.lead_contact.phone,
                        preferred_contact_method: response.data?.lead_contact.preferred_contact_method,
                    }
                };
                dispatch(leadActions.saveLead(newCreateLead));
            } else if (response?.status === 404) {
                if (LeadDetail === 'LeadDetail') {
                    dispatch(leadActions.saveLeadDetail(null));
                    dispatch(leadActions.setLeadDetailNotFound(true));
                } else {
                    dispatch(updateError({ message: 'Lead not found', success: false }));
                }
            } else {
                if (LeadDetail === 'LeadDetail') {
                    dispatch(leadActions.saveLeadDetail(null));
                }
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(leadActions.hasError(error?.message));
        }
    };
}

export function followUpAppointmentHandler(appointmentData) {
    return dispatch(leadActions.isAppointment(appointmentData));
}

export function appointmentsAttended(practiceId, leadId, id, data, handleClose) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/attended/`, 'post', data);
            if (response?.status === 200) {
                handleClose({ success: true });
                dispatch(startLoadingData(false));
                return;
            }
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
            dispatch(setLoader(false));
            dispatch(updateError({ message: JSON.stringify(response.data || 'Something went wrong'), success: false }));
        } catch (error) {
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
            dispatch(setLoader(false));
            dispatch(updateError({ message: JSON.stringify(error.message || 'Something went wrong'), success: false }));
        }
    };
}

export function addAppointmentNotes(practiceId, leadId, id, data, handleClose) {
    return async () => {
        try {
            const {
                newLeadDetail: {
                    attentendAppoiment,
                },
                appointmentNotes
            } = store.getState().lead;
            if (!attentendAppoiment?.callAppointmentNote) {
                dispatch(attenedAppoimentNotes(practiceId, leadId, handleClose));
                return;
            }
            if (appointmentNotes.length === 0) {
                const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/appointment_notes/`, 'post', data);
                if (response?.status === 201) {
                    dispatch(attenedAppoimentNotes(practiceId, leadId, handleClose));
                    dispatch(updateError({ success: true, message: 'Appointment notes added successfully' }));
                    return;
                }
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            } else {
                dispatch(updateAppointmentNotes(practiceId, leadId, id, appointmentNotes, data, handleClose));
            }
            dispatch(updateCompleteStatus(false));
        } catch (error) {
            dispatch(updateCompleteStatus(false));
            dispatch(updateError({ message: error.message, success: false }));
        }
    };
}

export function getAppointmentNotes(practiceId, leadId, id, handleNext) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/appointment_notes/`);
            if (response?.status === 200) {
                dispatch(leadActions.appointmentNotesSlice(response.data.results));
            } else {
                const message = response?.data && typeof response.data === 'object'
                    ? Object.entries(response.data).map(([k, v]) => `${k}: ${v}`).join(', ')
                    : response?.data?.detail || `Failed to fetch appointment notes (HTTP ${response?.status || 'timeout'})`;
                handleNext?.({ message, success: false });
                dispatch(leadActions.hasError(message));
            }
        } catch (error) {
            const message = error?.message || 'An error occurred while fetching appointment notes';
            handleNext?.({ message, success: false });
            dispatch(leadActions.hasError(message));
        }
    };
}

export function updateAppointmentNotes(practiceId, leadId, id, appointmentNotes, data, handleClose) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/appointment_notes/${appointmentNotes[0].id}/`, 'put', data);
            if (response?.status === 200) {
                dispatch(attenedAppoimentNotes(practiceId, leadId, handleClose));
                dispatch(updateError({ success: true, message: 'Appointment notes updated successfully' }));
                return;
            }
            dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
        } catch (error) {
            const message = error?.message || 'An error occurred while updating appointment notes';
            handleClose({
                message,
                success: false
            });
            dispatch(leadActions.hasError(message));
        }
    };
}

export function ConsultationAttended(handleClose) {
    return async () => {
        try {
            const { newLeadDetail, followLead } = store.getState().lead;
            const { depositData } = store.getState().deposit;
            const { practiceId } = store.getState().practiceTreatmentList;
            const { lead_treatments: leadTreatment, lead_appointment: leadAppoiment } = followLead ?? {};
            dispatch(startLoadingData(true));
            dispatch(setLoader(true));
            if (depositData?.isDepositFlow) {
                dispatch(creteTreatmentPaymentFlow());
            }
            if (leadTreatment && leadTreatment.length && leadAppoiment && leadAppoiment.length) {
                const treatment = getCurrentTreatmentData(leadTreatment[0]);
                const appointment = leadAppoiment.filter((el) => el?.status === 'ATTENDED' || el?.status === 'CONSULTATION_ATTENDED')[0];
                dispatch(leadActions.saveAppointment(appointment));
                dispatch(leadActions.saveTreatment(treatment));
                dispatch(leadActions.saveNewLeadDetail({ lead_treatment: treatment }));
                const { noteDetail } = newLeadDetail?.attentendAppoiment || {};
                if (noteDetail) dispatch(addAppointmentNotes(practiceId, followLead.id, appointment.id, noteDetail, handleClose));
                if (newLeadDetail?.addReminder) {
                    const leadNoteData = {
                        lead: followLead.id,
                        note: 'FOLLOW_UP',
                        treatment: getCurrentTreatmentIdV2(followLead?.lead_treatments[0]?.id)
                    };
                    dispatch(addNotes(leadNoteData, practiceId, handleClose, 'attended'));
                }
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
            dispatch(setLoader(false));
        }
    };
}

export function RecordAttended(handleClose) {
    return async () => {
        try {
            const { newLeadDetail: { attentendAppoiment } = {}, followLead } = store.getState().lead;
            const { depositData } = store.getState().deposit;
            const { practiceId } = store.getState().practiceTreatmentList;
            const { lead_treatments: leadTreatment, lead_appointment: leadAppoiment } = followLead ?? {};
            dispatch(startLoadingData(true));
            dispatch(setLoader(true));
            if (leadTreatment && leadTreatment.length && leadAppoiment && leadAppoiment.length) {
                const treatment = leadTreatment[0];
                const appointment = leadAppoiment.filter((el) => el?.status === 'BOOKED' || el?.status === 'CONSULTATION_BOOKED')?.[0];
                if (!appointment) {
                    dispatch(updateError({ message: 'No active booked appointment found for this lead', success: false }));
                    dispatch(startLoadingData(false));
                    dispatch(setLoader(false));
                    return;
                }
                dispatch(leadActions.saveAppointment(appointment));
                dispatch(leadActions.saveTreatment(treatment));
                dispatch(leadActions.saveNewLeadDetail({ lead_treatment: treatment }));
                const { noteDetail } = attentendAppoiment || {};
                const appointmentDetail = {
                    contacted_via: appointment.contacted_via,
                    datetime: appointment.datetime,
                    lead_treatment: appointment.lead_treatment,
                    method: appointment.method,
                    note: appointment.note,
                };
                if (appointment?.assignees?.length > 0) {
                    appointmentDetail.assignees = appointment.assignees;
                }
                // Wrap the success callback so the loader always resets before
                // the gate dismisses and the Finish button becomes visible.
                // Spread args so attenedAppoimentNotes can still pass ('finish', leadId)
                // to callers that need it (e.g. NewLead.jsx handleClose).
                const closeAndClearLoader = (...args) => {
                    dispatch(startLoadingData(false));
                    dispatch(setLoader(false));
                    if (handleClose) handleClose(...args);
                };
                const handleApi = (data) => {
                    if (depositData?.isDepositFlow) {
                        dispatch(creteTreatmentPaymentFlow());
                    }
                    if (data.success) {
                        dispatch(addAppointmentNotes(practiceId, followLead.id, appointment.id, noteDetail, closeAndClearLoader));
                    } else {
                        // attendmentsAttended returned non-200 — clear loader so UI unblocks.
                        dispatch(startLoadingData(false));
                        dispatch(setLoader(false));
                    }
                };
                dispatch(appointmentsAttended(practiceId, followLead.id, appointment.id, appointmentDetail, handleApi));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
            dispatch(setLoader(false));
        }
    };
}

export function recordUnAttended(handleClose) {
    return async () => {
        try {
            const { newLeadDetail, followLead } = store.getState().lead;
            dispatch(startLoadingData(true));
            const { faildAttended, } = newLeadDetail;
            const { lead_treatments: leadTreatment, lead_appointment: leadAppoiment } = followLead ?? {};
            const { practiceId } = store.getState().practiceTreatmentList;
            const appoinmentID = leadAppoiment?.filter((el) => el?.status === 'BOOKED' || el?.status === 'CONSULTATION_BOOKED');
            const statuses = ['FAILED_TO_ATTEND_CONSULTATION', 'FAILED_TO_ATTEND'];
            const appointmentDetail = {
                lead_treatment: leadTreatment[0].id,
            };
            if (leadTreatment && leadTreatment.length) {
                const treatment = leadTreatment[0];
                const { newLeadDetail: { archiveLead }, tableRowLead } = store.getState().lead;
                dispatch(leadActions.saveTreatment(treatment));
                dispatch(leadActions.saveNewLeadDetail({ lead_treatment: treatment }));

                if (!statuses.includes(tableRowLead?.status) && faildAttended.activeTab !== 'Reschedule' && appoinmentID.length > 0) {
                    dispatch(FailedToAttendAppointment(appointmentDetail, leadTreatment[0]?.lead, appoinmentID[0].id, practiceId, handleClose, faildAttended?.activeTab));
                    return;
                }
                if (faildAttended.activeTab === 'Unable to contact') {
                    dispatch(unableToContact(handleClose));
                    return;
                }
                if (faildAttended.activeTab === 'Archive') {
                    const archiveNote = {
                        ...archiveLead.notes,
                        lead: tableRowLead.lead_id
                    };
                    dispatch(addNotes(archiveNote, practiceId, handleClose));
                    return;
                }
                if (faildAttended.activeTab === 'Reschedule') {
                    dispatch(Reschedule(handleClose));
                }
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
        }
    };
}

export function unableToContact(handleClose, isNoNotes) {
    return async () => {
        try {
            const { newLeadDetail, createLead } = store.getState().lead;
            const { unableToContact } = newLeadDetail;
            const { practiceId } = store.getState().practiceTreatmentList;
            if (unableToContact && unableToContact.noteDetail) {
                const noteDetail = {
                    ...unableToContact.noteDetail,
                    contacted_via: 'PHONE'
                };

                if (!isNoNotes) {
                    dispatch(addNotes(noteDetail, practiceId, handleClose, 'unable'));
                    return;
                }

                if (newLeadDetail.addReminder) {
                    const reminderDetail = {
                        ...newLeadDetail.addReminder,
                        lead_treatment: getCurrentTreatmentIdV2(createLead.lead_treatment ? createLead.lead_treatment.id : 0),
                    };
                    dispatch(addReminder(reminderDetail, practiceId, handleClose, 'unable'));
                    return;
                }
                // dispatch(updateError({ message: 'Note added successfully', success: true }));
                dispatch(updateCompleteStatus(false));
                handleClose('finish', noteDetail?.lead);
                dispatch(startLoadingData(false));
                return;
            }

            if (newLeadDetail.addReminder) {
                const reminderDetail = {
                    ...newLeadDetail.addReminder,
                    lead_treatment: createLead.lead_treatment ? createLead.lead_treatment.id : 0,
                };
                dispatch(addReminder(reminderDetail, practiceId, handleClose, 'finish'));
                return;
            }
            handleClose('finish');
            dispatch(startLoadingData(false));
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
        }
    };
}

export function Reschedule(handleClose) {
    return async () => {
        try {
            const { newLeadDetail: { startTreatment }, createLead, followLead, tableRowLead } = store.getState().lead;
            const { lead_treatments: leadTreatment } = followLead ?? {};
            const { practiceId } = store.getState().practiceTreatmentList;
            if (startTreatment) {
                const treatment = leadTreatment[0];
                if (JSON.stringify(startTreatment.updatedTreatment.treatment) !== JSON.stringify(leadTreatment[0].treatment) || JSON.stringify(startTreatment.updatedTreatment.custom_price) !== JSON.stringify(leadTreatment[0].price) || JSON.stringify(startTreatment.updatedTreatment.teethAmount) !== JSON.stringify(leadTreatment[0]?.leadtreatment_specification?.teeth_count)) {
                    const updateTreatment = {
                        ...startTreatment.updatedTreatment,
                        lead: treatment?.lead || followLead?.id,
                        id: getCurrentTreatmentIdV2(createLead.lead_treatment.id)
                    };
                    dispatch(UpdateTreatmentV2(updateTreatment, practiceId, handleClose, 'RescheduleTreatment'));
                    return;
                }
                if (tableRowLead?.status === 'FAILED_TO_ATTEND_CONSULTATION' || tableRowLead?.status === 'FAILED_TO_ATTEND') {
                    dispatch(addAppointment(startTreatment?.appointmentDetail, practiceId, treatment?.lead || followLead?.id, handleClose, 'Reschedule'));
                    return;
                }
                dispatch(UpdateAppointment(startTreatment?.appointmentDetail, practiceId, handleClose, 'Reschedule'));
                return;
            }
            handleClose('finish');
            dispatch(startLoadingData(false));
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(updateCompleteStatus(false));
            dispatch(startLoadingData(false));
        }
    };
}

export function attenedAppoimentNotes(practiceId, leadId, handleClose) {
    return async () => {
        const {
            newLeadDetail: {
                lead_treatment: leadTreatment,
                attentendAppoiment,
                startTreatment,
                archiveLead,
            },
            newLeadDetail,
            createLead
        } = store.getState().lead;
        if (attentendAppoiment?.activeTab === 'Starting treatment') {
            const treatment = {
                treatment: leadTreatment?.treatment,
                custom_price: leadTreatment?.price
            };
            if (JSON.stringify(startTreatment.updatedTreatment) !== JSON.stringify(treatment)) {
                const updateTreatment = {
                    ...(startTreatment?.updatedTreatment ?? {}),
                    lead: leadId,
                    id: getCurrentTreatmentIdV2(createLead?.lead_treatment.id)
                };
                dispatch(UpdateTreatmentV2(updateTreatment, practiceId, handleClose, 'finish'));
                return;
            }
            const startTreatments = {
                ...startTreatment.updatedTreatment,
                lead: leadId,
                id: getCurrentTreatmentIdV2(createLead?.lead_treatment.id)
            };
            dispatch(StartingTreatment(startTreatments, practiceId, handleClose, 'finish'));
            dispatch(updateCompleteStatus(false));
            return;
        }
        if (attentendAppoiment?.activeTab === 'Follow Up' && newLeadDetail.addReminder) {
            const reminderDetail = {
                ...newLeadDetail.addReminder,
                lead: createLead.id,
                lead_treatment: getCurrentTreatmentIdV2(createLead.lead_treatment.id) || 0,
                lead_appointment: getCurrentLeadAppointmentId(createLead.lead_appointment.id) || 0
            };
            dispatch(addReminder(reminderDetail, practiceId, handleClose));
            return;
        }
        if (attentendAppoiment?.activeTab === 'Treatment complete') {
            dispatch(CompleteTreatment(leadTreatment, leadId, getCurrentTreatmentIdV2(createLead.lead_treatment.id), practiceId, handleClose));
            return;
        }
        if (attentendAppoiment?.activeTab === 'Archive') {
            const archiveNote = {
                ...archiveLead.notes,
                lead: leadId
            };
            dispatch(addNotes(archiveNote, practiceId, handleClose));
            return;
        }
        dispatch(updateCompleteStatus(false));
        dispatch(updateError({ message: 'Treatment and Appointment updated successfully', success: true }));
        handleClose('finish', leadId);
        dispatch(startLoadingData(false));
    };
}

export function cancelAppointment(practiceId, leadId, id, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/cancelled/`, 'post');
            if (response?.status === 200) {
                handleSuccess({ success: true, message: 'Appointment cancel successfully' });
                dispatch(getAppointment(practiceId, leadId));

                // If Dentally is enabled and this lead has a linked Dentally appointment,
                // flag for cancellation so the OverView card prompts the user.
                const { dentallyEnabledGlobal } = store.getState().practice;
                if (dentallyEnabledGlobal) {
                    try {
                        const leadRes = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/`);
                        const metadata = Array.isArray(leadRes?.data?.lead_metadata) ? leadRes.data.lead_metadata : [];
                        const dentallyApptId = metadata.find(m => m.key === 'dentally_appointment_id')?.value;
                        if (dentallyApptId) {
                            dispatch(patchLeadMetadata(practiceId, leadId, [
                                { key: 'pending_dentally_cancel', value: 'yes' },
                            ]));
                        }
                    } catch {
                        // Non-critical — CRM cancel already succeeded
                    }
                }
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function updateAppointmentDetail(practiceId, leadId, id, detail, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/appointments/${id}/`, 'patch', detail);
            if (response?.status === 200) {
                handleSuccess({ success: true, message: 'Appointment updated successfully' });
            } else {
                dispatch(updateError({ message: JSON.stringify(response?.data) || 'Something went wrong', success: false }));
            }
        } catch (error) {
            handleSuccess({ success: false, message: error.message || 'Something went wrong' });
            dispatch(leadActions.hasError(error.message));
        }
    };
}

// -----------------------------------------------------------------------------
// revertAttended  (Phase 5.3 — undo attendance)
//
// Attempts to revert a lead treatment from CONSULTATION_ATTENDED back to
// CONSULTATION_BOOKED.
//
// The BE endpoint is speculative (`/api/v1/lead-treatments/{id}/revert_attended/`).
// If the BE returns 404 or 501 (not yet implemented), we gracefully fall back
// with a toast instead of throwing.
//
// @param {number|string} leadTreatmentId — the lead_treatment.id to revert.
// @param {function}      [callback]      — called on success.
// -----------------------------------------------------------------------------
export function revertAttended(leadTreatmentId, callback) {
    return async () => {
        try {
            const response = await callApi(
                `/api/v1/lead-treatments/${leadTreatmentId}/revert_attended/`,
                'post',
                {}
            );
            if (response?.status === 200 || response?.status === 201) {
                callback?.();
            } else if (response?.status === 404 || response?.status === 501) {
                dispatch(updateError({
                    message: 'Undo not available — please change status manually.',
                    success: false,
                }));
            } else {
                dispatch(updateError({
                    message: response?.data?.detail || 'Failed to undo attendance.',
                    success: false,
                }));
            }
        } catch (error) {
            dispatch(updateError({
                message: 'Undo not available — please change status manually.',
                success: false,
            }));
        }
    };
}

export function updateTransitionTime(data, practiceId, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${data?.lead}/treatments/${data.id}/update_transition_time/`, 'patch', data);
            if (response?.status === 200) {
                handleSuccess({ success: true, message: 'Transition time updated successfully' });
            } else {
                dispatch(updateCompleteStatus(false));
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
                dispatch(startLoadingData(false));
            }
        } catch (error) {
            dispatch(leadActions.hasError(error.message));
            dispatch(startLoadingData(false));
        }
    };
}
